import { APP_ENVIRONMENT } from "../../_RuntimeConfig/_Config/Acomodar/AppEnvironment.js";
import { OBJECT_FREEZE_HELPER } from "../../../_Helpers/ObjectFreeze.helper.js";

const NORMALIZE_URL = (value = "") => String(value).trim().replace(/\/+$/, "");
const NORMALIZE_VERSION = (value = "") => String(value).trim().replace(/^v/i, "");

const REQUIRE_WHEN_CONNECTED = (value, label) => {
    if (APP_ENVIRONMENT.BACKEND.HAS_CONNECT && !value) {
        throw new Error(`[APP] Falta la configuracion requerida del backend: ${label}`);
    }
    return value;
};

const BUILD_API_URL = (baseUrl, version) => {
    const base = NORMALIZE_URL(baseUrl);
    if (!base) return "";
    const cleanVersion = NORMALIZE_VERSION(version);
    if (!cleanVersion) return base;
    const versionSegment = `v${cleanVersion}`;
    if (new RegExp(`/api/${versionSegment}$`, "i").test(base)) return base;
    if (/\/api\/v\d+$/i.test(base)) return base.replace(/\/api\/v\d+$/i, `/api/${versionSegment}`);
    if (/\/api$/i.test(base)) return `${base}/${versionSegment}`;
    return `${base}/api/${versionSegment}`;
};

const BACKEND = APP_ENVIRONMENT.BACKEND;
const API_VERSION = NORMALIZE_VERSION(BACKEND.API_VERSION);
const ENDPOINT_BASE = REQUIRE_WHEN_CONNECTED(NORMALIZE_URL(BACKEND.URLS.ENDPOINT), "REACT_APP_BACKEND_API_URL_ENDPOINT");
const SOCKET_URL = REQUIRE_WHEN_CONNECTED(NORMALIZE_URL(BACKEND.URLS.SOCKET), "REACT_APP_BACKEND_API_URL_SOCKET");
const STATIC_URL = REQUIRE_WHEN_CONNECTED(NORMALIZE_URL(BACKEND.URLS.STATIC), "REACT_APP_BACKEND_STATIC_STRING_CONNECTION");
const DOCUMENTATION_BASE = NORMALIZE_URL(BACKEND.URLS.DOCUMENTATION);

const _SCHEMA = {
    HAS_CONNECT: BACKEND.HAS_CONNECT,
    RUNTIME_ENVIRONMENT: APP_ENVIRONMENT.RUNTIME.ENVIRONMENT,
    BACKEND_MODE: BACKEND.CONNECTION_TYPE,
    API_PORT: BACKEND.API_PORT,
    API_VERSION: API_VERSION ? `v${API_VERSION}` : "",
    API_URL: BUILD_API_URL(ENDPOINT_BASE, API_VERSION),
    API_ENDPOINT_BASE: ENDPOINT_BASE,
    SOCKET_URL,
    STATIC_URL,
    DOCUMENTATION_URL: DOCUMENTATION_BASE ? BUILD_API_URL(DOCUMENTATION_BASE, API_VERSION) : "",
};

export const API_BASE = OBJECT_FREEZE_HELPER.DEEP_FREEZE(_SCHEMA);
